export default [
  {
    path: '/app/collections',
    name: 'Collections',
    component: () => import('@/views/Admin/Collections/Index.vue'),
    meta: {
      pageTitle: 'Koleksiyonlar',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_COLLECTIONS_LIST',
      action: 'read',
    },
  },
  {
    path: '/app/collections/add',
    name: 'CollectionsAdd',
    component: () => import('@/views/Admin/Collections/Add.vue'),
    meta: {
      pageTitle: 'Koleksiyonlar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/collections',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_COLLECTIONS_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/collections/edit/:id',
    name: 'CollectionsEdit',
    component: () => import('@/views/Admin/Collections/Edit.vue'),
    meta: {
      pageTitle: 'Koleksiyonlar',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/collections',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_COLLECTIONS_EDIT',
      action: 'read',
    },
  },
]
